import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * @typedef {{}} FillTextProps
 */

/**
 * FillText FillText.
 * @extends {Base<FillTextProps>}
 */
export default class FillText extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'FillText',
    refs: ['title'],
  };

  /**
   * Mount Component
   * @returns {void}
   */
  mounted() {
    gsap.registerPlugin(SplitText, ScrollTrigger);
    const split = new SplitText(this.$refs.title, { type: 'lines' });

    split.lines.forEach((target) => {
      gsap.to(target, {
        backgroundPositionX: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: target,
          scrub: 1,
          start: 'center center',
          end: 'bottom center',
        },
        onComplete: () => {
          const strong = target.querySelector('strong');
          if (strong) {
            strong.style.color = '#000';
            strong.classList.add('is-active');
          }
        },
        onReverseComplete: () => {
          const strong = target.querySelector('strong');
          if (strong && strong.classList.contains('is-active')) {
            strong.style.color = '';
            strong.classList.remove('is-active');
          }
        },
      });
    });
  }
}
